import { API_URL } from "../config/connect";

const request = async (path, { method = "GET", body } = {}) => {
    const token = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const d = data.detail;
        const message =
            (typeof d === "string" && d) ||
            (Array.isArray(d) && d.map((x) => `${(x.loc || []).slice(1).join(".")}: ${x.msg}`).join("; ")) ||
            `HTTP ${response.status}`;
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

export const listTariffs = () => request("/api/v1/admin/tariffs").then((d) => d.tariffs || []);
export const createTariff = (body) => request("/api/v1/admin/tariffs", { method: "POST", body });
export const updateTariff = (id, body) => request(`/api/v1/admin/tariffs/${id}`, { method: "PATCH", body });
export const deleteTariff = (id) => request(`/api/v1/admin/tariffs/${id}`, { method: "DELETE" });
